import React, { useEffect } from "react";
import BannerSectionStyle3 from "../Section/BannerSection/BannerSectionStyle3";
import BannerSectionStyle4 from "../Section/BannerSection/BannerSectionStyle4";
import Section from "../Section";
import FeaturesSectionStyle2 from "../Section/FeaturesSection/FeaturesSectionStyle2";
import TeamSection from "../Section/TeamSection";
import AwardSectionStyle2 from "../Section/AwardSection/AwardSectionStyle2";
import { pageTitle } from "../../helpers/PageTitle";
import SectionHeading from "../SectionHeading";
import { teamData } from "../../utils/Data/teamData";
import { rwoData } from "../../utils/Data/rwoData";
import debru from "../../../src/assets/Tech Team/dhruba.png";
import benjamin from "../../../src/assets/Tech Team/benjamin_photo.png";
import abhijeetImg from "../../../src/assets/Support Officer/ABHIJEET.jpg";
import anadita from "../../../src/assets/Front Office Executive/Anadita.png";
import RWOSection from "../Team/RWOSection";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import { directorData } from "../../utils/Data/directorData";
import Profilemodal from "../profile/Profilemodal";
import { Link } from "react-router-dom";
import { Volume2 } from "lucide-react";
import Certficate from "../../../src/assets/certficates/Certificate.jpg";
import masiCertificate from "../../../src/assets/certficates/MASI_CERTIFICATE.jpg";
import dpiitCertificate from "../../../src/assets/certficates/DPIIT_Recognition_Certificate.jpg";

const featureListData = [
  {
    title: "Experienced Healthcare Professionals",
    subTitle:
      "Our team includes experienced healthcare professionals who are dedicated to providing the best possible Healthcare services to the society.",
    iconUrl: "images/icons/professional.svg",
  },
  {
    title: "Comprehensive Services",
    subTitle:
      "We offer a wide range of healthcare services, from preventive care to specialized reverting plan for complex conditions.",
    iconUrl: "images/icons/comprehensive.svg",
  },
  {
    title: "Beneficiary-centered <br /> Approach",
    subTitle:
      "We believe in caring each health seeker as an individual, and we take the time to understand your unique health needs and concerns.",
    iconUrl: "images/icons/patient.svg",
  },
  {
    title: "State-of-the-art Facilities",
    subTitle:
      "Our healthcare professionals are equipped with the latest technology and equipment to provide health-seekers with the most advanced care & counselling possible.",
    iconUrl: "images/icons/facilities.svg",
  },
];




const awardData = [
  {
    iconUrl: Certficate, // local image
    title: "",
  },
  {
    iconUrl: masiCertificate, // local image
    title: "",
  },
  {
    iconUrl: dpiitCertificate, // local image
    title: "",
  },
];



// const awardData = [
//   {
//     iconUrl: "/images/",
//     title: "Malcolm Baldrige National Quality Award",
//   },
  // { iconUrl: "/images/icons/award.svg", title: "HIMSS Davies Award" },
  // {
  //   iconUrl: "/images/icons/award.svg",
  //   title: "Healthgrades National’s Best Hospital",
  // },
  // {
  //   iconUrl: "/images/icons/award.svg",
  //   title: "Joint Commission Gold Seal of Approval",
  // },
// ];

const TeamData = [
  { img: benjamin, name: "Benjamin Dutta", Designation: "Chief ITWO, Backend" },

  { img: debru, name: "Dhrubajyoti Bora", Designation: "ITWO, Frontend" },
];

export default function About() {
  pageTitle("About");

  const [selectedMember, setSelectedMember] = useState(null);
  const location = useLocation();

  useEffect(() => {
    setSelectedMember(null)
  }, [location]);

  return (
    <>
      <BannerSectionStyle3
        bgUrl="/images/about/banner_bg.svg"
        imgUrl="/images/nhwm/about_us_home.jpg"
        title="Welcome to <br />National Healthcare & Wellness Mission"
        subTitle="Your Partner in Healthcare and Wellness"
      />
      <Section topMd={140} topLg={200} topXl={80}>
        <SectionHeading title="About NHWM" center />
        <div className="md:w-[70%] mx-auto p-3 md:text-xl text-lg text-justify">
          <p className="mt-4 text-[#274760]">
            The National Healthcare and Wellness Mission (NHWM), in
            collaboration with Optim Health and Wellness (OPC) Pvt. Ltd., is
            dedicated to promoting health and well-being across India. Our goal
            is to educate and empower individuals to prevent and reverse
            degenerative lifestyle diseases through expert guidance and support.
          </p>
          <p className=" text-[#274760]">
            We offer a range of free and paid healthcare and wellness services,
            including:
          </p>
          <div>
            <ul className="px-5 font-semibold  text-[#274760] text-left">
              <li>Awareness & Education Programs</li>
              <li>Nutritional Assessments</li>
              <li>Coaching & Training</li>
              <li>Personalized Counselling</li>
            </ul>
          </div>
          <p className=" text-[#274760]">
            NHWM provides membership options for Indian citizens, available for
            one year, five years, or a lifetime. Members can actively
            participate in awareness programs as part-time or full-time
            contributors.
          </p>
          <p className=" text-[#274760]">
            For those seeking expert guidance, our Health Seeker Registration
            grants access to free awareness sessions and affordable personalized
            counselling, with flexible three-month and yearly plans.
          </p>
          <p className=" text-[#274760]">
            Additionally, NHWM offers a Wellness Assurance Plan, which includes
            free supplements at a budget-friendly cost, available in three-month
            and yearly options.
          </p>
          <p className=" text-[#274760]">
            Since 2012, NHWM has been a pioneer in nutritional assessments and
            wellness awareness programs for all age groups. Through expert
            counselling and education, we support the prevention and reversal of
            lifestyle diseases such as diabetes, high blood pressure, heart
            disease, cancer, arthritis, and obesity.
          </p>
        </div>
      </Section>
      <Section topMd={125} topLg={0} topXl={85} bottomMd={100} bottomLg={50}>
        <FeaturesSectionStyle2
          sectionTitle="Why Choose Us"
          imgUrl="/images/about/why_choose_us_image.jpg"
          data={featureListData}
        />
      </Section>
      <Section topMd={200} topLg={0} topXl={20}>
        <div className="w-[80%] mx-auto">
          <SectionHeading title="Our Mission" center />
          <p className="mt-4 md:text-3xl text-2xl capitalize text-center text-[#274760]">
            Helping 10 Million people by 31st Dec' 2030 to get prevented or
            reverse from Diabetes & other Lifestyle Diseases.
          </p>
        </div>
        <div className="w-[80%] mx-auto mt-12">
          <SectionHeading title="Our Vision" center />
          <p className="mt-4 md:text-3xl text-2xl capitalize text-center text-[#274760]">
            Becoming a Pioneer Organization in India by Educating & Helping
            People How to Live a Healthy, Wealthy & Happy Life.
          </p>
        </div>
      </Section>
      <Section topMd={140} topLg={20} topXl={75}>
        <div className="">
          <TeamSection sectionTitle=" Meet Our Director" data={directorData} />
        </div>
        <Section topMd={140} topLg={0} topXl={0}>
          <div className="md:mt-[0]">
            <h2 className="cs_section_title md:text-[35px] text-[32px] text-left absolute left-[15px] md:absolute md:left-[122px] m-0">
              Message from Mission Director...
            </h2>
            <br />
            <br className="block md:hidden" />

            <div className="md:w-[85%] md:relative md:left-[110px] p-3">
              <img
                src="/images/icons/quote.svg"
                alt="Icon"
                className="ml-[-70px]"
              />
              <p className="text-lg md:text-xl text-justify text-[#274760]">
                We are honored to share our commitment to promoting health and
                well-being as part of our moral and social responsibility.
                Through our Healthcare Awareness Programme, we strive to help
                individuals stay healthy by offering comprehensive health
                assessments (health check-ups) and personalized counselling,
                both free and paid. This initiative is purely educational,
                focusing on nutritional health check-ups to empower people with
                knowledge on preventing and reversing lifestyle diseases.
                <br /> <br />
                To expand our impact, we have launched the National Healthcare &
                Wellness Mission, a pan-India initiative. As part of this
                mission, we conducted the Basic Recruitment Test (BRT) 2023-24
                to select the right individuals to join us. However, only a
                small number of candidates qualified, leaving us short of our
                requirements. To address this, we will conduct another BRT in
                November, 2025, with advertisements set to be released in July &
                August, 2025.
                <br /> <br />
                Our mission aims to educate and support 10 million people in
                preventing and reversing lifestyle diseases by 31st of December,
                2030. We invite all Indian citizens to join us in this
                collective effort and share valuable insights to help us grow.
                Together, we can educate and empower people to safeguard their
                health and prevent future crises.
                <br />
                <br />
                This mission is a shared moral and social responsibility, and we
                are committed to maintaining trust and integrity in all our
                activities. We strictly prohibit any monetary scams or
                anti-social activities in the name of NHWM, ensuring positive
                and ethical engagement with society.
              </p>
              <p className="text-lg md:text-xl text-start text-[#274760] mt-2">
                Sincerely, <br />
                Dr. Monideep Boruah <br />
                Mission Director, NHWM
              </p>
            </div>
          </div>
        </Section>

        <TeamSection sectionTitle="Meet Our Advisors" data={teamData} />
      </Section>
      <br />
      <div className="bg-white p-8 rounded-lg  text-center  w-sm md:max-w-xl mx-auto">
        <h4 className="text-[#274760] text-5xl">Our Executive Team</h4>
        {/* Support Officer */}

        <div
          className="mb-10 border-1 rounded-lg border-[#307bc4] p-4 lg:w-[1110px] md:w-[710px] md:ml-[-100px]  lg:ml-[-300px] cursor-pointer"
          onClick={() =>
            setSelectedMember({
              img: abhijeetImg,
              name: "Abhijeet Borah",
              Designation: "Support Officer",
            })
          }
        >
          <img
            src={abhijeetImg}
            alt="Abhijeet Borah"
            className="w-[340px] h-[350px] mx-auto object-cover border-2 border-blue-400 rounded-3xl"
          />
          <div className="font-semibold mt-2 uppercase">Abhijeet Borah</div>
          <div className="text-blue-700 font-medium uppercase">
            Support Officer
          </div>
          <div className="text-[#274760] text-[15px] flex flex-col items-center gap-2 font-semibold">
            <div className="flex items-center gap-2">
              <Volume2 />
              <a
                href="https://youtu.be/Dr1XL5Qj2DA"
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => e.stopPropagation()}
              >
                <span>Hear From Me</span>
              </a>
            </div>
          </div>
        </div>

        <br />
        <div
          className="border-1 rounded-lg border-[#307bc4] p-4 md:w-[710px] lg:w-[1110px] lg:ml-[-300px] md:ml-[-100px]  w-full cursor-pointer"
          onClick={() =>
            setSelectedMember({
              img: anadita,
              name: "Anindita Konwar",
              Designation: "HR Executive",
            })
          }
        >
          <img
            src={anadita}
            alt="Abhijeet Borah"
            className="w-[250px] h-[320px] mx-auto object-cover border-2 border-blue-400 rounded-3xl"
          />
          <div className="font-semibold mt-2 uppercase">ANINDITA KONWAR</div>
          <div className="text-blue-700 font-medium uppercase">
            HR EXECUTIVE
          </div>
        </div>
        <br />
        <br />

        {/* Tech Team */}
        <h3 className="text-3xl font-bold text-blue-700 mb-4 uppercase">
          Tech Team
        </h3>

        <div className="border-1 rounded-lg border-[#307bc4] p-4 md:w-[710px] lg:w-[1110px] lg:ml-[-300px] md:ml-[-100px] w-full">
          <div
            className="flex justify-center cursor-pointer"
            onClick={() => setSelectedMember(TeamData[0])}
          >
            <div className="text-center pb-10">
              <img
                src={TeamData[0].img}
                alt={TeamData[0].name}
                className="w-[250px] h-[320px] mx-auto border-2 border-[#307bc4] rounded-3xl object-cover"
              />
              <div className="font-semibold mt-2 uppercase">
                {TeamData[0].name}
              </div>
              <div className="text-blue-700 font-medium uppercase">
                {TeamData[0].Designation}
              </div>
            </div>
          </div>

          {/* Second row - 2 members spaced */}
          <div className="flex justify-center gap-10 md:gap-70 lg:gap-80 flex-wrap">
            {TeamData.slice(1).map((member, index) => (
              <div
                key={index}
                className="text-center cursor-pointer"
                onClick={() => setSelectedMember(member)}
              >
                <img
                  src={member.img}
                  alt={member.name}
                  className="w-[250px] h-[320px] mx-auto border-2 border-[#307bc4] rounded-3xl object-cover"
                />
                <div className="font-semibold mt-2 uppercase">
                  {member.name}
                </div>
                <div className="text-blue-700 font-medium uppercase">
                  {member.Designation}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="border-1 rounded-lg border-[#307bc4] p-4 md:w-[710px] lg:w-[1110px] lg:ml-[-300px] md:ml-[-100px] mt-[50px] w-full">
          <div
            className="flex justify-center cursor-pointer"
          >
            <div className="text-center pb-10 flex flex-col items-center justify-center">
              <div className="aspect-auto h-72 w-60 rounded-2xl border"></div>
              <p className="text-[#274760] font-medium uppercase mt-3">
                Front Office Executive Cum Office Assistant
              </p>
            </div>
          </div>
          <div className="hidden sm:hidden lg:block">
            <Profilemodal
              member={selectedMember}
              onClose={() => setSelectedMember(false)}
            />
          </div>
        </div>
      </div>

      <RWOSection members={rwoData} />

      <div className="text-[#274760] text-center  container text-sm cursor-pointer hover:text-blue-800 transition-all duration-300">
        <Link to="/ourteam">Click to Explore Our Complete Team</Link>
      </div>

      <Section
        topMd={190}
        topLg={55}
        topXl={105}
        bottomMd={200}
        bottomLg={30}
        bottomXl={110}
      >
        <AwardSectionStyle2
          sectionTitle="Winning Awards and <br />Recognition"
          sectionTitleUp="AWARDS"
          sectionSubTitle="We have been recognized for our commitment to <br />excellence in healthcare."
          data={awardData}
        />
      </Section>
      <Section className="cs_footer_margin_0">
        <BannerSectionStyle4
          bgUrl="images/nhwm/about_bg.jpg"
          title="Don’t Let Your Health <br />Take a Backseat!"
          subTitle="Schedule an appointment with one of our experienced <br />Healthcare Professionals today!"
          center
        />
      </Section>
    </>
  );

}


